/**
 * Developed By Aritra Basak, EY
 * (Latest)
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import { asyncGet, asyncPost } from "../../common/utils";
import { URI_PREFIX, URI } from "../../constants/index";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import InfoTwoTone from "@material-ui/icons/InfoTwoTone";
import moment from "moment";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import RefreshIcon from "@material-ui/icons/Refresh";
import Box from "@material-ui/core/Box";
import { Divider } from "@mui/material";
import { Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import "../../assets/styles/Consents.css";
import "../../assets/styles/App.css";

const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: 12,
    overflow: "scroll",
  },
  paper: {
    backgroundColor: "white !important",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    minWidth: 170,
  },
  button: {
    margin: theme.spacing(1),
  },
});

function createData(
  name,
  healthid,
  consentstatus,
  fromdate,
  todate,
  expiryon,
  reporttype
) {
  return {
    name,
    healthid,
    consentstatus,
    fromdate,
    todate,
    expiryon,
    reporttype,
  };
}

const defaultState = {
  healthId: "",
  healthshowLoader: true,
  showModalLoader: false,
  requestId: "",
  patientInfo: null,
  isPatientFound: false,
  isModalOpen: false,
  modalFor: "",
  opConsultation: false,
  dischargeSummary: false,
  diagnosticReports: false,
  prescription: false,
  isViewer: false,
  consentList: [],
  selectedConsentId: null,
  selectedConsentArtefactId: null,
  page: 0,
  fromRec: 1,
  toRec: 10,
  size: 10,
  totalRec: 0,
  fromDate: "",
  toDate: moment().format("YYYY-MM-DDTHH:mm"),
  expiryOn: moment().add("days", 1).format("YYYY-MM-DDTHH:mm"),
  purpose: "CAREMGT",
};
class Consents extends Component {
  constructor(props) {
    super(props);
    this.state = JSON.parse(JSON.stringify(defaultState));
  }
  //Called immadiately as soon as a component is rendered.
  componentDidMount = () => {
    this.setState({ showLoader: true });
    this.fetchConsentList();
    this.intervalConsentList = setInterval(
      () => this.fetchConsentList(),
      10000
    );
  };

  refreshConsentList = () => {
    this.setState({ showLoader: true });
    this.fetchConsentList();
  };
  //To Fetch the list of available consent that has been generated by the all the users till now
  fetchConsentList = async () => {
    console.log(global.healthId);
    const url =
      URI.getConsentList +
      "?institute=" +
      global.instituteId +
      "&page=" +
      this.state.page +
      "&size=" +
      this.state.size;
    const res = await asyncGet(url, true, global.token, true, false);
    if (res.status == 2000) {
      //debugger;
      console.log(res);
      this.setState({
        showLoader: false,
        consentList: res.data ? res.data.content : null,
        totalRec: res.data ? res.data.totalElements : 0,
      });
    } else {
      this.setState({ showLoader: false });
      this.handleModalOpen(
        "successMsg",
        "Message from ABDM : Unable to fetch consent list. Please reload from menu."
      );
    }
  };

  valueChange = (e, id) => {
    //debugger;
    const __oo = {};
    __oo[id] = e.target.value;
    this.setState(__oo);
  };
  //To Find Patient Details for raising new Consents By the given ABHA ID
  onFindPatient = async () => {
    console.log(
      'healthID : "' +
        this.state.healthId +
        '" , global.healthIdParam "' +
        global.healthIdParam +
        '"'
    );
    if (
      global.healthIdParam === "" &&
      (this.state.healthId === "" || this.state.healthId === undefined)
    ) {
      this.handleModalOpen(
        "successMsg",
        "Message from ABDM : Please specify the ABHA Address"
      );
    } else {
      if (global.healthIdParam !== "") {
        this.setState({ healthId: global.healthIdParam });
      }
      this.setState({ showModalLoader: true });
      const __oo = {
        healthId:
          global.healthIdParam !== ""
            ? global.healthIdParam
            : this.state.healthId,
        requesterType: "HIU",
        requesterId: global.instituteId,
      };
      const res = await asyncPost(
        URI.patientFind,
        __oo,
        true,
        true,
        global.token
      );
      if (res && res.status == 2000) {
        // alert("Requested for patient info.");
        this.setState({
          requestId: res.data.requestId,
          modalFor: "showpatientinfo",
          showModalLoader: false,
          patientInfo: null,
        });
        this.interval = setInterval(() => this.getPatientInfo(), 3000);
      } else {
        this.setState({ showModalLoader: false });
        this.handleModalOpen("successMsg", res.ndhmErrorMsg.message);
        this.handleModalOpen("successMsg", res.ndhmErrorMsg.details[0].message);
      }
    }
  };

  getPatientInfo = async () => {
    const __oo = {
      requestId: this.state.requestId,
    };
    const res = await asyncPost(
      URI.getPatientInfo,
      __oo,
      true,
      true,
      global.token
    );
    // debugger;
    console.log("getPatientInfo : " + URI.getPatientInfo);
    if (res && res.status == 2000) {
      //debugger;
      clearInterval(this.interval);
      this.setState({
        patientInfo: res.data,
        isPatientFound: true,
        healthId: res.data.healthId,
      });
      console.log("patientInfo : " + JSON.stringify(res));
    }
    // else if (res && res.status == 4000){
    //     clearInterval(this.interval);
    //     this.setState({ patientInfo: "No record found.", healthId: null });
    // }
  };

  componentWillUnmount() {
    clearInterval(this.intervalConsentList);
    clearInterval(this.interval);
  }

  onConsentRequest = async () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    var formattedDate = year + "-" + month + "-" + day;
    console.log("Formatted Date" + formattedDate);
    let maxDate = moment(formattedDate).utc();
    //debugger;
    let hiTypes = [];
    if (this.state.opConsultation) hiTypes.push("OPConsultation");

    if (this.state.dischargeSummary) hiTypes.push("DischargeSummary");

    if (this.state.diagnosticReports) hiTypes.push("DiagnosticReport");

    if (this.state.prescription) hiTypes.push("Prescription");

    if (this.state.immunizationRecord) hiTypes.push("ImmunizationRecord");

    if (this.state.healthDocumentRecord) hiTypes.push("HealthDocumentRecord");

    if (this.state.wellnessRecord) hiTypes.push("WellnessRecord");

    let fDt = moment(this.state.fromDate).utc();
    console.log("fdt", fDt);
    console.log("maxDate", maxDate);
    let tDt = moment(this.state.toDate).utc();
    let eDt = moment(this.state.expiryOn).utc();
    let cDt = moment().add(4, "minutes").utc();
    if (hiTypes.length > 0 && tDt.isSameOrAfter(fDt) && eDt.isAfter(cDt)) {
      this.setState({ showModalLoader: true });

      const __oo = {
        purposeText:
          this.state.purpose == "CAREMGT" ? "Care Management" : " Self Request",
        purposeCode: this.state.purpose,
        healthId: this.state.healthId,
        hiuId: global.instituteId,
        requesterName: global.user !== null ? global.user : global.instituteId,
        requesterIdentifierType: "",
        requesterIdentifierValue: "",
        requesterIdentifiersystem: "",
        hiTypes: hiTypes,
        accessMode: "VIEW",
        dateRangeFrom: moment(this.state.fromDate)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS"),
        dateRangeTo: moment(this.state.toDate)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS"),
        dataEraseAt: moment(this.state.expiryOn)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS"),
        frequencyUnit: "DAY",
        frequencyValue: 1,
        repeats: 0,
        patientName: this.state.patientInfo.name,
      };
      //To raise a Consent Request with respect to the details provided by the user.
      const res = await asyncPost(
        URI.consentRequestInit,
        __oo,
        true,
        true,
        global.token
      );
      if (res && res.status == 2000) {
        this.setState({ showModalLoader: false });
        this.handleModalClose();
        this.handleModalOpen("successMsg", "Consent initiated.");
      } else {
        this.setState({ showModalLoader: false });
        this.handleModalOpen(
          "generalMsg",
          "Message from ABDM : Unable to initiate consent."
        );
        this.handleModalOpen("generalMsg", res.ndhmErrorMsg.message);
        this.handleModalOpen("generalMsg", res.ndhmErrorMsg.details[0].message);
      }
    } else if (!tDt.isSameOrAfter(fDt)) {
      this.handleModalOpen(
        "generalMsg",
        "Health Info To Date must be greater than Health Info From Date"
      );
    } else if (hiTypes.length == 0) {
      this.handleModalOpen(
        "generalMsg",
        "Please select atleast one Health Info Type"
      );
    } else if (!eDt.isAfter(cDt)) {
      this.handleModalOpen(
        "generalMsg",
        "The Expiry Date must be atleast 5 minute later"
      );
    }
  };

  handleModalOpen = (modalFor, generalMsg) => {
    this.setState({
      isModalOpen: true,
      modalFor: modalFor,
      generalMsg: generalMsg,
    });
  };
  //To send Request to Consent Manager to share data about the selected User to the ABDM Application
  healthInfoRequest = async (
    selectedConsentArtefactId,
    consentReqId,
    isDecodedReceived
  ) => {
    //debugger;
    this.setState({ showLoader: true });
    global.consentReqId = consentReqId;
    global.consentArtefactId = selectedConsentArtefactId;
    if (isDecodedReceived == "T") {
      this.setState({ showLoader: false });
    } else {
      // const __oo = {
      //   consentId: consentReqId,
      // };
      // const res = await asyncPost(
      //   URI.healthInfoCmRequest,
      //   __oo,
      //   true,
      //   true,
      //   global.token
      // );
      // this.setState({ showLoader: false });

      if (selectedConsentArtefactId.indexOf(",") > -1) {
        let arr = selectedConsentArtefactId.split(",");
        for (let i = 0; i < arr.length; i++) {
          const __oo = {
            consentId: arr[i],
          };
          const res = await asyncPost(
            URI.healthInfoCmRequest,
            __oo,
            true,
            true,
            global.token
          );
          if (res && res.status == 2000) {
            // this.handleModalClose();
          }
        }
        this.setState({ showLoader: false });
      } else {
        const __oo = {
          consentId: selectedConsentArtefactId,
        };
        // debugger;
        const res = await asyncPost(
          URI.healthInfoCmRequest,
          __oo,
          true,
          true,
          global.token
        );
        if (res && res.status == 2000) {
          // this.handleModalClose();
        }
        this.setState({ showLoader: false });
      }
    }
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false, modalFor: "" });
  };

  handleChange = (id) => {
    const value = !this.state[id];
    this.setState({ id: value });
  };

  showViewer = (selectedConsentArtefactId, consentReqId) => {
    global.consentReqId = consentReqId;
    global.consentArtefactId = selectedConsentArtefactId;
    // global.reportType = healthInfoType
    // if (global.reportType && (global.reportType.toLowerCase() == 'prescription'))
    //     global.reportName = "Prescription"
    // else if (global.reportType && (global.reportType.toLowerCase() == 'diagnosticreport'))
    //     global.reportName = "Diagnostic Report"
    // else if (global.reportType && (global.reportType.toLowerCase() == 'dischargesummary'))
    //     global.reportName = "Discharge Summary"
    // else if (global.reportType && (global.reportType.toLowerCase() == 'opconsultation'))
    //     global.reportName = "OP Consultation Report"

    // global.reportData = decodedValue;
  };

  handlePrevious = () => {
    let page = this.state.page;
    let fromRec = this.state.fromRec;
    let toRec = this.state.toRec;
    if (page > 0) {
      this.setState({ showLoader: true });
      this.fetchConsentList();
      this.setState({
        page: page - 1,
        fromRec: fromRec - this.state.size,
        toRec:
          fromRec + this.state.size > this.state.totalRec
            ? fromRec + this.state.size - (this.state.size + 1)
            : toRec - this.state.size,
      });
    }
  };

  handleNext = () => {
    let page = this.state.page;
    let fromRec = this.state.fromRec;
    let toRec = this.state.toRec;
    // debugger;
    if (page < this.state.totalRec / this.state.size - 1) {
      this.setState({ showLoader: true });
      this.fetchConsentList();
      this.setState({
        page: page + 1,
        fromRec: fromRec + this.state.size,
        toRec:
          toRec + this.state.size > this.state.totalRec
            ? this.state.totalRec
            : toRec + this.state.size,
      });
    }
  };

  CustomTooltipContent = ({ value }) => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested On:{" "}
            {value.createdDate !== null
              ? moment(value.createdDate).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Granted On:{" "}
            {value.consentGrantedOn !== null
              ? moment.utc(value.consentGrantedOn).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Revoked On:{" "}
            {value.consentRevokeOn !== null
              ? moment.utc(value.consentRevokeOn).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Denied On:{" "}
            {value.consentDeniedOn !== null
              ? moment.utc(value.consentDeniedOn).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Expired On:{" "}
            {moment(value.expiryOn).diff(moment(), "days") >= 0 &&
            (value.status.toLowerCase() === "granted" ||
              value.status.toLowerCase() === "requested" ||
              value.status.toLowerCase() === "denied")
              ? "NA"
              : value.status.toLowerCase() === "denied" ||
                value.status.toLowerCase() === "revoked"
              ? "NA"
              : moment
                  .utc(value.expiryOn)
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            HI Types Requested:{" "}
            <ul style={{ listStyleType: "disc", margin: "0" }}>
              {value.healthInfoTypeRequested !== null ? (
                value.healthInfoTypeRequested
                  .split(",")
                  .map((hiType, index) => (
                    <li key={index} style={{ fontSize: "14px" }}>
                      {hiType}
                    </li>
                  ))
              ) : (
                <li style={{ fontSize: "14px" }}>NA</li>
              )}
            </ul>
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested From:{" "}
            {value.fromDateRequested !== null
              ? moment.utc(value.fromDateRequested).local().format("DD-MM-YYYY")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested To:{" "}
            {value.toDateRequested !== null
              ? moment.utc(value.toDateRequested).local().format("DD-MM-YYYY")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested Expiry On:{" "}
            {value.expiryOnRequested !== null
              ? moment
                  .utc(value.expiryOnRequested)
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")
              : "NA"}{" "}
          </span>
        </Grid>
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;
    const regex = /,/gi;
    return (
      <React.Fragment>
        <Paper
          className={classes.paper}
          style={{ padding: "0px", width: "100%" }}
        >
          {!this.state.showLoader ? (
            <div>
              <div style={{ width: "100%" }}>
                <div style={{ float: "left", width: "60%" }}>
                  <Grid
                    container
                    direction={"row"}
                    spacing={5}
                    style={{ width: "100%", marginBottom: 10 }}
                  >
                    <Grid item style={{ marginLeft: 10 }}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                        }}
                        onClick={() => this.handleModalOpen("findpatient")}
                      >
                        NEW CONSENT REQUEST
                      </Button>

                      {/* <Button variant="contained" style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                        }} className={classes.button}>FETCH CONSENT DETAIL</Button> */}
                      <Button
                        variant="contained"
                        color="default"
                        style={{ color: "#f53169d9" }}
                        className={classes.button}
                        onClick={() => this.refreshConsentList()}
                        startIcon={<RefreshIcon />}
                      >
                        Refresh
                      </Button>
                    </Grid>
                  </Grid>
                </div>
                <div style={{ float: "right", marginTop: 30, marginRight: 10 }}>
                  <strong>Total Record(s): </strong>
                  {this.state.totalRec}
                </div>
              </div>
              <Table style={{ paddingTop: "10px" }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      <strong>ABHA Address</strong>
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      <strong>Patient Name</strong>
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      <strong>Status</strong>
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      <strong>Granted HI Types</strong>
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      <strong>Granted From</strong>
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      <strong>Granted To</strong>
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      <strong>Granted Expiry</strong>
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "1px solid #cdcab2",
                      }}
                    >
                      <strong>More Info</strong>
                    </TableCell>
                    <TableCell
                      style={{ borderBottom: "1px solid #cdcab2" }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.consentList.map((row, index) => (
                    <TableRow
                      style={{ borderBottom: "1px solid #cdcab2" }}
                      key={index}
                    >
                      <TableCell
                        style={{
                          borderBottom: "1px solid #cdcab2",
                          width: "150px",
                        }}
                      >
                        {row.healthId}
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: "1px solid #cdcab2",
                          width: "150px",
                        }}
                      >
                        {row.patientName}
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: "1px solid #cdcab2",
                          width: "150px",
                        }}
                      >
                        {moment(row.expiryOn).diff(moment(), "days") >= 0 ? (
                          <div className="d-flex">
                            <div
                              class={
                                row.status.toLowerCase() === "requested"
                                  ? "requesteddot"
                                  : row.status.toLowerCase() === "granted"
                                  ? "granteddot"
                                  : "expireddot"
                              }
                              style={{ float: "left" }}
                            ></div>
                            <div style={{ float: "left", marginLeft: 5 }}>
                              {row.status}
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div
                              className="expireddot"
                              style={{ float: "left" }}
                            ></div>
                            <div style={{ float: "left", marginLeft: 5 }}>
                              {row.status.toLowerCase() === "requested" ||
                              row.status.toLowerCase() === "granted"
                                ? "EXPIRED"
                                : row.status}
                            </div>
                          </div>
                        )}
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: "1px solid #cdcab2",
                          width: "100px",
                        }}
                      >
                        <p>
                          {row.healthInfoType
                            ? row.healthInfoType.replaceAll(regex, "\n")
                            : ""}
                        </p>
                      </TableCell>
                      <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                        {moment.utc(row.fromDate).local().format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                        {moment.utc(row.toDate).local().format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                        {moment
                          .utc(row.expiryOn)
                          .local()
                          .format("DD-MM-YYYY HH:mm:ss")}
                      </TableCell>
                      <TableCell
                        style={{
                          borderBottom: "1px solid #cdcab2",
                        }}
                      >
                        <Tooltip
                          title={<this.CustomTooltipContent value={row} />}
                          arrow
                        >
                          <Button>
                            <InfoTwoTone />
                          </Button>
                        </Tooltip>
                      </TableCell>

                      <TableCell
                        style={{
                          borderBottom: "1px solid #cdcab2",
                          width: "190px",
                        }}
                      >
                        {row.status === "GRANTED" && (
                          <Grid container direction={"row"} spacing={5}>
                            <Grid item>
                              {moment(row.expiryOn).diff(moment(), "days") >=
                              0 ? (
                                <a
                                  href="javascript:void(0);"
                                  onClick={() =>
                                    this.healthInfoRequest(
                                      row.consentArtefacts,
                                      row.consentId,
                                      row.isDecodedReceived
                                    )
                                  }
                                  style={{
                                    textDecoration: "none",
                                    color: global.secondaryColour,
                                  }}
                                >
                                  Request Data
                                </a>
                              ) : null}
                              {row.isDecodedReceived == "T" &&
                                moment(row.expiryOn).diff(moment(), "days") >=
                                  0 && (
                                  <Button
                                    component={Link}
                                    to="/viewer"
                                    onClick={() =>
                                      this.showViewer(
                                        row.consentArtefacts,
                                        row.consentId
                                      )
                                    }
                                  >
                                    <KeyboardArrowRightIcon
                                      style={{
                                        color: global.secondaryColour,
                                      }}
                                    />
                                  </Button>
                                )}
                            </Grid>
                          </Grid>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell
                      colSpan="10"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Box justifyContent="flex-end" display="flex">
                        <Button
                          type="button"
                          onClick={() => this.handlePrevious()}
                        >
                          <KeyboardArrowLeftIcon />
                        </Button>
                        <div style={{ marginTop: 8 }}>
                          {this.state.fromRec}-{this.state.toRec} of{" "}
                          {this.state.totalRec}
                        </div>
                        <Button type="button" onClick={() => this.handleNext()}>
                          <KeyboardArrowRightIcon />
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          ) : (
            <div style={{ textAlign: "center", marginTop: 60 }}>
              <CircularProgress style={{ color: global.secondaryColour }} />
              <h5 style={{ marginTop: 5 }}>Loading...</h5>
            </div>
          )}
        </Paper>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={this.state.isModalOpen}
          onClose={() => this.handleModalClose()}
          closeAfterTransition
          BackdropComponent={Backdrop}
          id="model1"
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={this.state.isModalOpen}>
            {this.state.modalFor == "newconsent" ? (
              <div
                className={classes.paper}
                id="ModalTable1"
                style={{
                  borderRadius: 10,
                  width: "50%",
                  maxHeight: "80%",
                  overflowY: "auto",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    width="25"
                    height="27"
                    viewBox="0 0 128 128"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <style>
                        {`.cls-1{fill:#ffe082}
                          .cls-2{fill:#404040}
                          .cls-3{fill:#9e9e9e}
                          .cls-4{fill:#f5f5f5}`}
                      </style>
                    </defs>
                    <path
                      className="cls-1"
                      d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                    />
                    <path
                      className="cls-2"
                      d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                    />
                    <path
                      className="cls-3"
                      d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                    />
                    <path
                      className="cls-2"
                      d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                    <path
                      className="cls-2"
                      d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                    <path
                      className="cls-2"
                      d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Initiate Consent Request
                  </Typography>
                </Box>
                <Divider sx={{ width: "50%", mb: 0.5 }} />
                <Divider sx={{ width: "40%", mb: 2 }} />
                <div>
                  {!this.state.showModalLoader ? (
                    <Grid
                      container
                      direction={"row"}
                      spacing={8}
                      style={{ margin: 2 }}
                    >
                      <Grid item>
                        <TextField
                          id="healthId"
                          label="ABHA Address"
                          value={this.state.healthId}
                          className={this.props.txtField}
                          type="text"
                          onChange={(e) => this.valueChange(e, "healthId")}
                          style={{ width: "130%", marginRight: "5%" }}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          id="patientName"
                          label="Patient Name"
                          value={this.state.patientInfo.name}
                          className={this.props.txtField}
                          type="text"
                          onChange={(e) => this.valueChange(e, "patientName")}
                          style={{ width: "130%" }}
                        />
                      </Grid>
                      <Grid item>
                        {/* <TextField id="purpose" label="Purpose of request" type="text" InputLabelProps={{ shrink: true }} onChange={(e) => this.valueChange(e, 'purpose')} /> */}
                        <FormControl className={classes.formControl}>
                          <InputLabel id="purposeLabel">Purpose</InputLabel>
                          <Select
                            labelId="purpose"
                            id="purpose"
                            value={this.state.purpose}
                            onChange={(e) => {
                              this.setState({ purpose: e.target.value });
                            }}
                            className={classes.selectEmpty}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={"CAREMGT"}>
                              Care Management
                            </MenuItem>
                            <MenuItem value={"PATRQT"}>Self Requested</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <TextField
                          id="fromDate"
                          value={this.state.fromDate}
                          label="Health Info From"
                          type="datetime-local"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.valueChange(e, "fromDate")}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          id="toDate"
                          value={this.state.toDate}
                          label="Health Info To"
                          type="datetime-local"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const selectedDate = new Date(e.target.value);
                            const currentDate = new Date();
                            if (selectedDate > currentDate) {
                              // If the selected date is greater than the current date, do not update the state
                              this.handleModalOpen(
                                "generalMsg",
                                "Please select a date that is not in the future."
                              );
                            } else {
                              this.valueChange(e, "toDate");
                            }
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <TextField
                          id="expiryOn"
                          value={this.state.expiryOn}
                          label="Consent Expiry"
                          type="datetime-local"
                          className={classes.textField}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => this.valueChange(e, "expiryOn")}
                        />
                      </Grid>

                      <Grid item>
                        <FormControl
                          component="fieldset"
                          className={classes.formControl}
                        >
                          <FormLabel component="legend">
                            Health Info Type
                          </FormLabel>
                          <FormGroup>
                            <Grid container direction={"row"} spacing={3}>
                              <Grid item>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.opConsultation}
                                      onChange={(e) => {
                                        this.setState({
                                          opConsultation: e.target.checked,
                                        });
                                      }}
                                      name="opConsultation"
                                    />
                                  }
                                  label="OP Consultation"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.dischargeSummary}
                                      onChange={(e) => {
                                        this.setState({
                                          dischargeSummary: e.target.checked,
                                        });
                                      }}
                                      name="dischargeSummary"
                                    />
                                  }
                                  label="Discharge Summary"
                                />
                              </Grid>
                              <Grid item>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.diagnosticReports}
                                      onChange={(e) => {
                                        this.setState({
                                          diagnosticReports: e.target.checked,
                                        });
                                      }}
                                      name="diagnosticReports"
                                    />
                                  }
                                  label="Diagnostic Reports"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.prescription}
                                      onChange={(e) => {
                                        this.setState({
                                          prescription: e.target.checked,
                                        });
                                      }}
                                      name="prescription"
                                    />
                                  }
                                  label="Prescription"
                                />
                              </Grid>
                              <Grid item>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.immunizationRecord}
                                      onChange={(e) => {
                                        this.setState({
                                          immunizationRecord: e.target.checked,
                                        });
                                      }}
                                      name="immunizationRecord"
                                    />
                                  }
                                  label="Immunization Record"
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.healthDocumentRecord}
                                      onChange={(e) => {
                                        this.setState({
                                          healthDocumentRecord:
                                            e.target.checked,
                                        });
                                      }}
                                      name="healthDocumentRecord"
                                    />
                                  }
                                  label="Record Artifact"
                                />
                              </Grid>
                              <Grid item>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.wellnessRecord}
                                      onChange={(e) => {
                                        this.setState({
                                          wellnessRecord: e.target.checked,
                                        });
                                      }}
                                      name="wellnessReord"
                                    />
                                  }
                                  label="Wellness Record"
                                />
                              </Grid>
                            </Grid>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: global.secondaryColour,
                            color: "#fff",
                          }}
                          onClick={() => this.onConsentRequest()}
                        >
                          Request Consent
                        </Button>
                      </Grid>
                    </Grid>
                  ) : (
                    <div style={{ textAlign: "center", marginTop: 50 }}>
                      <CircularProgress
                        style={{ color: global.secondaryColour }}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : this.state.modalFor == "findpatient" ? (
              <pre>
                <div className={classes.paper} style={{ borderRadius: 10 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 1,
                    }}
                  >
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 1024 1024"
                      className="icon me-2"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-label="Search icon"
                      role="img"
                    >
                      <defs>
                        <style>
                          {`.cls-1{fill:#ffe082}
                          .cls-2{fill:#404040}
                          .cls-3{fill:#9e9e9e}
                          .cls-4{fill:#f5f5f5}`}
                        </style>
                      </defs>
                      <path
                        className="cls-1"
                        d="M622.4 682.453333l60.330667-60.309333 256.405333 256.405333-60.330667 60.309334z"
                        fill="#616161"
                      ></path>
                      <path
                        d="M426.666667 426.666667m-341.333334 0a341.333333 341.333333 0 1 0 682.666667 0 341.333333 341.333333 0 1 0-682.666667 0Z"
                        fill="#616161"
                      ></path>
                      <path
                        d="M692.266667 753.92l60.309333-60.330667 185.514667 185.514667-60.330667 60.330667z"
                        fill="#37474F"
                      ></path>
                      <path
                        d="M426.666667 426.666667m-277.333334 0a277.333333 277.333333 0 1 0 554.666667 0 277.333333 277.333333 0 1 0-554.666667 0Z"
                        fill="#64B5F6"
                      ></path>
                      <path
                        d="M573.866667 302.933333c-36.266667-42.666667-89.6-68.266667-147.2-68.266666s-110.933333 25.6-147.2 68.266666c-8.533333 8.533333-6.4 23.466667 2.133333 29.866667 8.533333 8.533333 23.466667 6.4 29.866667-2.133333C341.333333 296.533333 381.866667 277.333333 426.666667 277.333333s85.333333 19.2 115.2 53.333334c4.266667 4.266667 10.666667 8.533333 17.066666 8.533333 4.266667 0 10.666667-2.133333 12.8-4.266667 8.533333-8.533333 8.533333-23.466667 2.133334-32z"
                        fill="#BBDEFB"
                      ></path>
                    </svg>
                    <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                      Search Patient via ABHA Address
                    </Typography>
                  </Box>
                  {/* Decorative Lines */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Divider sx={{ width: "50%", mb: 0.5 }} />
                    <Divider sx={{ width: "40%", mb: 2 }} />
                  </div>

                  <div>
                    {!this.state.showModalLoader ? (
                      <Grid container direction={"row"} spacing={1}>
                        <Grid item>
                          {global.healthIdParam === "" ? (
                            <TextField
                              id="healthId"
                              label="Enter the ABHA Address to find the patient"
                              type="text"
                              style={{ width: 320 }}
                              onChange={(e) =>
                                this.setState({ healthId: e.target.value })
                              }
                            />
                          ) : (
                            <TextField
                              id="healthId"
                              value={global.healthIdParam}
                              label="Enter the ABHA Address to find the patient"
                              type="text"
                              style={{ width: 300 }}
                            />
                          )}
                          {/* <TextField id="healthId" label="Enter ABHA Address to find the patient" type="text" style={{ width: 300 }} onChange={(e) => this.valueChange(e, 'healthId')} /> */}
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: global.secondaryColour,
                              color: "#fff",
                              paddingBottom: 10,
                              marginTop: 7,
                            }}
                            onClick={() => this.onFindPatient()}
                          >
                            Search Patient
                          </Button>
                        </Grid>
                      </Grid>
                    ) : (
                      <div style={{ textAlign: "center", marginTop: 5 }}>
                        <CircularProgress
                          style={{ color: global.secondaryColour }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </pre>
            ) : this.state.modalFor == "generalMsg" ||
              this.state.modalFor == "successMsg" ? (
              <pre>
                <div className={classes.paper} style={{ borderRadius: 10 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <svg
                      width="25"
                      height="27"
                      viewBox="0 0 128 128"
                      className="me-2"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <style>
                          {`.cls-1{fill:#ffe082}
                          .cls-2{fill:#404040}
                          .cls-3{fill:#9e9e9e}
                          .cls-4{fill:#f5f5f5}`}
                        </style>
                      </defs>
                      <path
                        className="cls-1"
                        d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                      />
                      <path
                        className="cls-2"
                        d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                      />
                      <path
                        className="cls-3"
                        d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                      />
                      <path
                        className="cls-2"
                        d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                      />
                      <line
                        className="cls-4"
                        x1="54"
                        x2="82"
                        y1="102"
                        y2="98"
                      />
                      <path
                        className="cls-2"
                        d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                      />
                      <line
                        className="cls-4"
                        x1="54"
                        x2="82"
                        y1="110"
                        y2="106"
                      />
                      <path
                        className="cls-2"
                        d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                      />
                    </svg>
                    <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                      Information
                    </Typography>
                  </Box>
                  {/* Decorative Lines */}
                  <Divider sx={{ width: "50%", mb: 0.5 }} />
                  <Divider sx={{ width: "40%", mb: 2 }} />
                  <div>{this.state.generalMsg}</div>
                  <br />
                  <div className="text-center">
                    {this.state.modalFor == "generalMsg" ? (
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                          marginTop: 5,
                        }}
                        onClick={() =>
                          this.setState({ modalFor: "newconsent" })
                        }
                      >
                        Back
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                          marginTop: 5,
                        }}
                        onClick={() => this.handleModalClose()}
                      >
                        Back
                      </Button>
                    )}
                  </div>
                </div>
              </pre>
            ) : (
              <pre>
                <div
                  className={classes.paper}
                  style={{
                    borderRadius: 10,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <svg
                      width="25"
                      height="27"
                      viewBox="0 0 128 128"
                      className="me-2"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <style>
                          {`.cls-1{fill:#ffe082}
                          .cls-2{fill:#404040}
                          .cls-3{fill:#9e9e9e}
                          .cls-4{fill:#f5f5f5}`}
                        </style>
                      </defs>
                      <path
                        className="cls-1"
                        d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                      />
                      <path
                        className="cls-2"
                        d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                      />
                      <path
                        className="cls-3"
                        d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                      />
                      <path
                        className="cls-2"
                        d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                      />
                      <line
                        className="cls-4"
                        x1="54"
                        x2="82"
                        y1="102"
                        y2="98"
                      />
                      <path
                        className="cls-2"
                        d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                      />
                      <line
                        className="cls-4"
                        x1="54"
                        x2="82"
                        y1="110"
                        y2="106"
                      />
                      <path
                        className="cls-2"
                        d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                      />
                    </svg>
                    <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                      Patient Information
                    </Typography>
                  </Box>
                  {/* Decorative Lines */}
                  <Divider sx={{ width: "50%", mb: 0.5 }} />
                  <Divider sx={{ width: "40%", mb: 2 }} />
                  <div>
                    {this.state.patientInfo ? (
                      // this.state.isPatientFound ?
                      <div>
                        <div>{this.state.patientInfo.id}</div>
                        <div>{this.state.patientInfo.name}</div>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: global.secondaryColour,
                            color: "#fff",
                            marginTop: 8,
                            marginLeft: "10%",
                          }}
                          onClick={() =>
                            this.setState({ modalFor: "newconsent" })
                          }
                        >
                          Next
                        </Button>
                      </div>
                    ) : (
                      // :
                      // <div>Patient Not Found.</div>
                      <div>
                        <strong>Loading...</strong>
                      </div>
                    )}
                  </div>
                </div>
              </pre>
            )}
          </Fade>
        </Modal>
      </React.Fragment>
    );
  }
}

Consents.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Consents);
